<template>
  <div class="mobile" id="mobile">
    <transition name="el-zoom-in-top">
      <div class="nav" v-show="isShowNav">
        <div class="navItem" @click="showDetails(1)" :class="{'changed':changedIndex==1}">首页</div>
        <div class="navItem" @click="showDetails(2)" :class="{'changed':changedIndex==2}">功能</div>
        <div class="navItem" @click="showDetails(3)" :class="{'changed':changedIndex==3}">服务</div>
        <div class="navItem" @click="showDetails(4)" :class="{'changed':changedIndex==4}">支持</div>
      </div>
    </transition>
    <div class="head_M">
      <div class="tab" @click="tab">
        <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/tab.svg" alt v-if="!isShowNav" />
        <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/close.svg" alt v-else />
      </div>
      <div class="logo">
        <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/LOGO.svg" alt />
      </div>
    </div>
    <div class="toTop" id="toTop" @click="scrollTop" v-show="isShowToTop"></div>
    <div class="contentBox" id="wrapper">
      <div class="banner_M listshow_M1">
        <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/banner.png" alt />
        <div class="tishi"></div>
      </div>
      <div class="mainImg_M">
        <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/img.png" class="bgImg" alt />
        <img
          src="https://files.easy2walk.com/wwweasy2walk/img/mobile/logo2.svg"
          alt
          class="logo_Main animated"
          :class="isShowLyxLogo ? 'fadeIn' :'fadeOut' "
        />
        <div class="text animated" :class="isShowLyxLogo ? 'fadeIn' :'fadeOut' ">
          在一个陌生的城市，语言不通、网络差异的情
          <br />况下能在商场和商场快速容易找到想买的商品
          <br />和想吃的美食并查看导航路线和消费方式 。
        </div>
      </div>
      <div class="mainItem shangchang shangchang_M listshow_M2">
        <div class="shouji animated" :class="isShowShangchang ? 'pulse' :''"></div>
        <div class="sucai animated" :class="isShowShangchang ? 'fadeInRight' :''"></div>
        <div class="tubiao"></div>
        <div class="title animated" :class="isShowShangchang ? 'fadeIn' :'fadeOut' ">商场与商场之间容易找到</div>
        <div
          class="text animated"
          :class="isShowShangchang ? 'fadeIn' :'fadeOut' "
          :style="{'animation-delay':' 0.3s'}"
        >
          Easy2Walk路易寻让你轻松地来往不同的商
          <br />场景点,无需使用不同的软件你都可以容易找
          <br />到你就近的商场位置,同时间可以店与店的导航
          <br />同时间可以店与店的导航附近的商场。
        </div>
      </div>
      <div class="mainItem shop shop_M">
        <div class="shouji animated" :class="{'pulse': isShowShop} "></div>
        <div class="sucai animated" :class="{'fadeInLeft': isShowShop} "></div>
        <div class="tubiao"></div>
        <div class="title animated" :class="isShowShop ? 'fadeIn' :'fadeOut' ">简单直接让你找到店铺</div>
        <div
          class="text animated"
          :class="isShowShop ? 'fadeIn' :'fadeOut' "
          :style="{'animation-delay':' 0.3s'}"
        >
          Easy2Walk路易寻含有模拟导航系
          <br />统,简单设定起点和终点就可以根据导
          <br />航快速找出您想去的店铺。
        </div>
      </div>
      <div class="mainItem pay pay_M" id="pay_M">
        <div class="shouji animated" :class="{'pulse': isShowPay} "></div>
        <div class="sucai animated" :class="{'fadeInRight': isShowPay} "></div>
        <div class="tubiao"></div>
        <div class="title animated" :class="isShowPay ? 'fadeIn' :'fadeOut' ">付款方式简单让你知道</div>
        <div
          class="text animated"
          :class="isShowPay ?'fadeIn' :'fadeOut' "
          :style="{'animation-delay':' 0.3s'}"
        >
          在一个陌生的地方 , 你未必知道你的付款
          <br />方式 能否使用 Easy2Walk路易寻轻松提
          <br />供付款资讯让您购物时作好准备。
        </div>
      </div>
      <div class="mainItem food food_M">
        <div class="shouji animated" :class="{'pulse': isShowFood} "></div>
        <div class="sucai animated" :class="{'fadeInLeft': isShowFood} "></div>
        <div class="tubiao"></div>
        <div class="title animated" :class="isShowFood ? 'fadeIn' :'fadeOut' ">美食从此不用等</div>
        <div
          class="text animated"
          :class="isShowFood ?'fadeIn' :'fadeOut' "
          :style="{'animation-delay':' 0.3s'}"
        >
          Easy2Walk 路易寻为你推介附近的
          <br />多种国际菜肴和菜品, 同时提供人均
          <br />消费让你出门时更有预算。
        </div>
      </div>
      <div class="mainItem youhui youhui_M">
        <div class="sucai animated">
          <img
            v-for="i in 4"
            :key="i"
            :src="(`https://files.easy2walk.com/wwweasy2walk/img/mobile/youhui/img${i}.svg`)"
            alt
            class="imgItem"
            :class="{'imgTranslate' : isShowYouHui}"
          />
        </div>
        <div class="tubiao animated"></div>
        <div class="title animated" :class="isShowYouHui ? 'fadeIn' :'fadeOut' ">商场优惠推送</div>
        <div
          class="text animated"
          :class="isShowYouHui ? 'fadeIn' :'fadeOut' "
          :style="{'animation-delay':' 0.3s'}"
        >
          第一时间推送最新的优惠活动
          <br />让商场消费者不再错过。
        </div>
      </div>
      <div class="tuiguangItem haiwai haiwai_M listshow_M3">
        <div class="topBg"></div>
        <div class="footBg"></div>
        <div
          class="phoneImg animated"
          :class="isShowHaiwai ? ' fadeInUp' :''"
          v-show="isShowHaiwai"
        ></div>
        <div
          class="phoneImg animated"
          :class="isShowHaiwai ? 'fadeInDown' :''"
          v-show="isShowHaiwai"
        ></div>
        <div class="title animated" :class="isShowHaiwai ?'fadeIn' :'fadeOut' ">海外推广</div>
        <div class="text animated" :class="isShowHaiwai ?'fadeIn' :'fadeOut' ">
          旅客去到一个陌生的地方，人生路不熟
          <br />找不到路，语言不通、怕菜式不合吃、
          <br />买了不好的东西，怕找路不方便。
        </div>
      </div>
      <div class="tuiguangItem city city_M">
        <div class="topBg"></div>
        <div class="footBg"></div>
        <div class="phoneImg animated" :class="isShowCity ? ' fadeInUp' :''" v-show="isShowCity"></div>
        <div class="phoneImg animated" :class="isShowCity ? 'fadeInDown' :''" v-show="isShowCity"></div>
        <div class="title animated" :class="isShowCity ? 'fadeIn' :'fadeOut' ">城市推广</div>
        <div class="text animated" :class="isShowCity ? 'fadeIn' :'fadeOut' ">
          对政府可推動当地旅游发展大帮助，管理
          <br />和推动都是十分容易加強城市的競爭力。
        </div>
        <div>
          <div class="swiper-container swiper_container_city iconBox">
            <div class="swiper-wrapper wrapper">
              <div
                class="swiper-slide iconItem animated"
                v-for="(item,index) in iconDataForCity"
                :key="index"
                :class="isShowCity ? 'fadeInUp' :''"
                :style="{'animation-delay':`${0.1*(index)}s` }"
              >
                <img :src="(`https://files.easy2walk.com/wwweasy2walk/img/mobile/city/icon${index+1}.png`)" alt />
                <br />
                {{item}}
              </div>
            </div>
            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev prev"></div>
            <div class="swiper-button-next next"></div>
          </div>
        </div>
      </div>
      <div class="tuiguangItem shangchangtuiguang shangchangtuiguang1">
        <div class="topBg"></div>
        <div class="footBg"></div>
        <div class="shouji animated" :class="{'fadeInDown':isShowTuiguangForShangchang}">
          <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/shouji.png" alt />
        </div>
        <div class="swiper-container swiper_container_shangchangtuiguang imgBox">
          <div class="swiper-wrapper wrapper">
            <div
              class="swiper-slide imgItem animated"
              v-for="(item,i) in shangChangTuiGuangData"
              :key="i"
            >
              <img :src="(`https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/img${i+1}.png`)" alt />
              <br />
              <span>{{item}}</span>
            </div>
          </div>
        </div>

        <div class="title animated" :class="isShowTuiguangForShangchang ? 'fadeIn' :'fadeOut' ">商场推广</div>
        <div class="text animated" :class="isShowTuiguangForShangchang ? 'fadeIn' :'fadeOut' ">
          减少客户排队询问的时间，让消费者手机
          <br />扫二维码即可找到自己想去的商铺。
        </div>
        <div class="saoma">长按识别二维码体验</div>
      </div>
      <div class="tuiguangItem shangchangtuiguang shangchangtuiguang2">
        <div class="topBg"></div>
        <div class="footBg"></div>
        <div class="shouji animated" :class="{'fadeInDown':isShowTuiguangForShangchang2}">
          <img src="https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/shouji.png" alt />
        </div>
        <div
          class="title animated"
          :class="isShowTuiguangForShangchang2 ? 'fadeIn' :'fadeOut' "
        >商场推广</div>
        <div class="text animated" :class="isShowTuiguangForShangchang2 ? 'fadeIn' :'fadeOut' ">
          减少客户排队询问的时间，让消费者手机
          <br />扫二维码即可找到自己想去的商铺。
        </div>
        <div class="saoma">长按识别二维码体验</div>
        <div class="bianjie">
          更便捷的服务
          <div class="icon"></div>
        </div>
        <div class="serveIconBox serveIconBox_M">
          <div
            class="serveIconItem animated"
            v-for="(item,index) in serveIconData"
            :key="index"
            :class="isShowTuiguangForShangchang_Icon ? 'fadeInUp' :'fadeOut'"
            :style="{'animation-delay':`${0.1*(index)}s` }"
          >
            <img :src="(`https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/serveIcon${index+1}.svg`)" alt />
            <br />
            {{item}}
          </div>
        </div>
      </div>
      <div class="footerBox footerBox_M listshow_M4">
        <div class="bgBox">
          <div class="telUs">欢迎联系我们</div>
          <div class="mallBox">
            <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/mallBig.svg" alt />
            <br />
            <span class="text">商务合作邮箱</span>
            <div class="icon"></div>
          </div>
          <a class="mallBtn" href="mailto:sw@chaunve.com" target="_blank">sw@chaunve.com</a>
        </div>
        <div class="bottomBox">
          <div class="copy">Copyright Chaunve Technology Co., Ltd., All rights reserved
            <br>
            <a
                href="https://beian.miit.gov.cn/"
              >粤ICP备09008348号</a>
          </div>
          <!-- <div class="mallBoxSmall">
            <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/mallSmall.svg" alt />
            <span>意见反馈邮箱：cuideng@chaunve.com</span>
          </div> -->
          <div class="logoBox">
              <a href="https://www.chaunve.com/">
                <img
                  src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGO1@2x.svg"
                  alt
                  class="logoItem1"
                />
              </a>
              <img
                src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGOfenge.svg"
                alt
                class="logoFenge"
              />
              <a href="#mobile">
                <img
                  src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGO2@2x.svg"
                  alt
                  class="logoItem2"
                />
              </a>
              <img
                src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGOfenge.svg"
                alt
                class="logoFenge"
              />
              <a href="https://www.cmappax.com">
                <img
                  src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGO3@2x.svg"
                  alt
                  class="logoItem3"
                />
              </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
// import Swiper from "swiper";
// import "swiper/dist/css/swiper.min.css";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      isShowNav: false, //是否显示导航页
      isShowToTop: false, //是否显示回到顶部

      iconDataForCity: [
        "机场",
        "广告灯箱",
        "高铁站",
        "高铁车厢广告",
        "商场",
        "机场高铁站服务台",
        "旅游大使",
        "服务人员",
        "保安"
      ],
      shangChangTuiGuangData: [
        "只需手机扫描一个二维码，就可找到你想去的地方。",
        "在标示上加上二维码，就像一个流动标示。",
        "扫描二维码，互动屏的功能就直接到你手机便用。",
        "客服台上加一台小平版，客户可自行查询店铺寻路。"
      ],
      serveIconData: [
        "最爱品牌",
        "寻路定位",
        "优惠推送",
        "大数据分析",
        "用户体验",
        "精准营销"
      ],
      isShowLyxLogo: false, //是否显示主图区域的logo和文字
      isShowShangchang: false, //是否显示商场的文字说明
      isShowShop: false, //是否显示店铺模块的文字说明
      isShowPay: false, //付款方式
      isShowFood: false, //美食不再等待
      isShowYouHui: false, //优惠
      isShowHaiwai: false, //海外推广
      isShowCity: false, //城市推广
      isShowTuiguangForShangchang: false, //商场推广
      isShowTuiguangForShangchang2: false,
      isShowTuiguangForShangchang_Icon: false,
      changedIndex: 1
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    var swiper_container_shangchangtuiguang = new Swiper(
      ".swiper_container_shangchangtuiguang",
      {
        freeMode: true,
        freeModeMomentumRatio: 1,
        slidesPerView: "auto",
        autoplay: true
      }
    );

    var mySwiper = new Swiper(".swiper_container_city", {
      freeMode: true,
      freeModeMomentumRatio: 1,
      slidesPerView: "auto",
      autoplay: true,
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    tab() {
      this.isShowNav = !this.isShowNav;
    },
    showDetails(num) {
      let that = this;
      this.changedIndex = num;
      var el = document.getElementsByClassName(`listshow_M${num}`)[0];
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      let topNum = el.offsetTop;
      this.$nextTick(function() {
        window.scrollTo({
          behavior: "smooth",
          top: topNum
        });
        that.tab();
      });
    },
    scrollTop() {
      const timeCount = 15; //时间系数
      // 取消一个通过调用requestAnimationFrame()方法添加到计划中的动画帧请求.
      cancelAnimationFrame(timer);
      /* requestAnimationFrame 会把每一帧中的所有DOM操作集中起来，
      在一次重绘或回流中就完成，并且重绘或回流的时间间隔紧紧跟随浏览器的刷新频率
      一般来说，这个频率为每秒60帧。 */
      let timer = requestAnimationFrame(function sTop() {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        if (top > 0) {
          //使用定时器，将scrollTop的值每次减少量（自行设置），直到减少到0，则滚动完毕
          document.body.scrollTop = document.documentElement.scrollTop =
            top - top / timeCount;
          timer = requestAnimationFrame(sTop);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
    handleScroll() {
      let that = this;
      //滚动距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      var mainImg_M = document
        .getElementsByClassName(`mainImg_M`)[0]
        .getBoundingClientRect().top;

      var mainImgHtmlElementClientTop = document
        .querySelector(".mainImg_M")
        .getBoundingClientRect().top;
      //商场距离网页顶端的距离
      var shangchangHtmlElementClientTop = document
        .getElementsByClassName(`shangchang_M`)[0]
        .getBoundingClientRect().top;
      //店铺
      var shopHtmlElementClientTop = document
        .getElementsByClassName(`shop_M`)[0]
        .getBoundingClientRect().top;

      var payHtmlElementClientTop = document
        .getElementById(`pay_M`)
        .getBoundingClientRect().top;

      var foodHtmlElementClientTop = document
        .getElementsByClassName(`food_M`)[0]
        .getBoundingClientRect().top;

      var youHuiHtmlElementClientTop = document
        .getElementsByClassName(`youhui_M`)[0]
        .getBoundingClientRect().top;

      var haiwai_M = document
        .getElementsByClassName(`haiwai_M`)[0]
        .getBoundingClientRect().top;

      var city_M = document
        .getElementsByClassName(`city_M`)[0]
        .getBoundingClientRect().top;

      var shangchangtuiguang1 = document
        .getElementsByClassName(`shangchangtuiguang1`)[0]
        .getBoundingClientRect().top;

      var shangchangtuiguang2 = document
        .getElementsByClassName(`shangchangtuiguang2`)[0]
        .getBoundingClientRect().top;

      var footerBox_M = document
        .getElementsByClassName(`footerBox_M`)[0]
        .getBoundingClientRect().top;

      // 获取的是浏览器可见区域高度（网页的可视区域的高度）（不滚动的情况下）
      var documentClientHeight =
        document.documentElement.clientHeight || window.innerHeight;

      if (scrollTop > mainImg_M) {
        this.isShowToTop = true;
        that.isShowLyxLogo = true;
      } else {
        this.isShowToTop = false;
        that.isShowLyxLogo = false;
      }

      // 主图进入可视区域
      that.isShowLyxLogo =
        documentClientHeight - mainImgHtmlElementClientTop >=
        document.querySelector(".mainImg_M").offsetHeight / 5
          ? true
          : false;
      // 商场与商场快速找到模块进入可视区
      if (
        documentClientHeight - shangchangHtmlElementClientTop >=
        document.querySelector(".shangchang_M").offsetHeight / 2
      ) {
        that.isShowShangchang = true;
        let timer = setTimeout(() => {
          that.isShowShangchang_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowShangchang = false;
        that.isShowShangchang_S = false;
      }

      // 简单直接让你找到店铺
      if (
        documentClientHeight - shopHtmlElementClientTop >=
        document.querySelector(".shop_M").offsetHeight / 2
      ) {
        that.isShowShop = true;
        let timer = setTimeout(() => {
          that.isShowShop_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowShop = false;
        that.isShowShop_S = false;
      }

      //付款方式
      if (
        documentClientHeight - payHtmlElementClientTop >=
        document.querySelector(".pay_M").offsetHeight / 2
      ) {
        that.isShowPay = true;
        let timer = setTimeout(() => {
          that.isShowPay_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowPay = false;
        that.isShowPay_S = false;
      }

      // 美食
      if (
        documentClientHeight - foodHtmlElementClientTop >=
        document.querySelector(".food_M").offsetHeight / 2
      ) {
        that.isShowFood = true;
        let timer = setTimeout(() => {
          that.isShowFood_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowFood = false;
        that.isShowFood_S = false;
      }
      // 优惠
      if (
        documentClientHeight - youHuiHtmlElementClientTop >=
        document.querySelector(".youhui_M").offsetHeight / 2
      ) {
        that.isShowYouHui = true;
      } else {
        that.isShowYouHui = false;
      }

      // 海外推广
      if (
        documentClientHeight - haiwai_M >=
        document.querySelector(".haiwai_M").offsetHeight / 2
      ) {
        that.isShowHaiwai = true;
      } else {
        that.isShowHaiwai = false;
      }

      //城市推广
      if (
        documentClientHeight - city_M >=
        document.querySelector(".city_M").offsetHeight / 2
      ) {
        that.isShowCity = true;
      } else {
        that.isShowCity = false;
      }

      //商场推广
      if (
        documentClientHeight - shangchangtuiguang1 >=
        document.querySelector(".shangchangtuiguang1").offsetHeight / 4
      ) {
        that.isShowTuiguangForShangchang = true;
      } else {
        that.isShowTuiguangForShangchang = false;
      }

      //商场推广2
      if (
        documentClientHeight - shangchangtuiguang2 >=
        document.querySelector(".shangchangtuiguang2").offsetHeight / 4
      ) {
        that.isShowTuiguangForShangchang2 = true;
      } else {
        that.isShowTuiguangForShangchang2 = false;
      }

      var serveIconBox = document
        .querySelector(".serveIconBox_M")
        .getBoundingClientRect().top;
      if (
        documentClientHeight - serveIconBox >=
        document.querySelector(".serveIconBox_M").offsetHeight / 1.5
      ) {
        that.isShowTuiguangForShangchang_Icon = true;
      } else {
        that.isShowTuiguangForShangchang_Icon = false;
      }

      var listshow1 = document.getElementsByClassName(`listshow_M${1}`)[0]
        .offsetTop;
      var listshow2 = document.getElementsByClassName(`listshow_M${2}`)[0]
        .offsetTop;
      var listshow3 = document.getElementsByClassName(`listshow_M${3}`)[0]
        .offsetTop;
      var listshow4 = document.getElementsByClassName(`listshow_M${4}`)[0]
        .offsetTop;
        // console.log(scrollTop,listshow1, listshow2,listshow3,listshow4);
       
      if (scrollTop < listshow2) {
        that.changedIndex = 1;
     
      } else if (scrollTop <= listshow3 && scrollTop >= listshow2) {
        that.changedIndex = 2;
       
      } else if (scrollTop <= listshow4 )  {
        that.changedIndex = 3;
        
      } else {
        that.changedIndex = 4;
       
      }
    }
  },
  filter: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

@media screen and (min-width: 320px) {html{font-size:17.06666px;}}
@media screen and (min-width: 360px) {html{font-size:19.2px;}}
@media screen and (min-width: 375px) {html{font-size:20px;}}
@media screen and (min-width: 400px) {html{font-size:21.33333px;}}
@media screen and (min-width: 414px) {html{font-size:22.08px;}}
@media screen and (min-width: 440px) {html{font-size:23.46666px;}}
@media screen and (min-width: 480px) {html{font-size:25.6px;}}
@media screen and (min-width: 520px) {html{font-size:27.73333px;}}
@media screen and (min-width: 560px) {html{font-size:29.86666px;}}
@media screen and (min-width: 600px) {html{font-size:32px;}}
@media screen and (min-width: 640px) {html{font-size:34.13333px;}}
@media screen and (min-width: 680px) {html{font-size:36.26666px;}}
@media screen and (min-width: 720px) {html{font-size:38.4px;}}
@media screen and (min-width: 750px) {html{font-size:40px;}}
@media screen and (min-width: 760px) {html{font-size:40px;}}
@media screen and (min-width: 800px) {html{font-size:40px;}}


.mobile {
  width: px375(375);
  overflow-x: hidden;

  .swiper-button-next:after, .swiper-button-prev:after{
    display: none;
  }

  .nav {
    position: fixed;
    top: px375(50);
    left: 0;
    bottom: 0;
    width: px375(375);
    height: 100vh;
    background-color: #fff;
    padding: px375(26);
    z-index: 9;
    .navItem {
      width: 100%;
      height: px375(40);
      line-height: px375(40);
      border-bottom: 1px solid #d9d9d9;
      font-size: px375(14);
      color: #371b2f;
    }
    .changed {
      color: #f05d52;
    }
  }

  .head_M {
    height: px375(50);
    width: px375(375);
    position: fixed;
    background-color: #fff;
    top: 0;
    left: 0;
    z-index: 9;
    // border-bottom: 1px #D9D9D9 solid;
    box-shadow: px375(0) px375(1) px375(10) px375(1) #d9d9d9;
    .tab {
      width: px375(50);
      height: px375(50);
      position: relative;
      img {
        width: px375(20);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .logo {
      width: px375(62);
      height: px375(20);
      font-size: 0;
      position: absolute;
      top: px375(14);
      left: px375(156);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .contentBox {
    // padding-top: px375(50);
    position: relative;
    width: px375(375);
  }
  .banner_M {
    width: 100%;
    height: px375(722);
    position: relative;
    img {
      width: 100%;
      height: px375(722);
      display: block;
    }
    .tishi {
      width: px375(36);
      height: px375(20);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/tishi.svg") center center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      bottom: px375(47);
      left: px375(170);
      animation: tishi1 2s linear infinite;
    }
    @-webkit-keyframes tishi1 {
      0% {
        transform: translateY(px375(-6));
      }
      25% {
        transform: translateY(px375(0));
      }
      50% {
        transform: translateY(px375(6));
      }
      75% {
        transform: translateY(px375(0));
      }
      100% {
        transform: translateY(px375(-6));
      }
    }
  }
  .toTop {
    position: fixed;
    right: px375(10);
    bottom: px375(30);
    width: px375(34);
    height: px375(34);
    background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/toTop.svg") center center no-repeat;
    background-size: 100% 100%;
    z-index: 8;
  }
  .mainImg_M {
    width: 100%;
    position: relative;
    .bgImg {
      width: 100%;
      display: block;
    }
    .logo_Main {
      width: px375(157);
      position: absolute;
      top: px375(230);
      left: px375(112);
    }
    .text {
      text-align: center;
      color: #fff;
      font-size: px375(14);
      min-width: px375(312);
      line-height: px375(35);
      position: absolute;
      top: px375(314);
      left: px375(36);
    }
  }
  .mainItem {
    width: 100%;
    height: px375(722);
    position: relative;
    background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/bg1.png") center center no-repeat;
    background-size: 100% 100%;
    text-align: center;
    &:nth-of-type(2n-1) {
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/bg2.png") center center no-repeat;
      background-size: 100% 100%;
    }
  }
  .shangchang {
    .shouji {
      position: absolute;
      left: px375(17);
      top: px375(360);
      height: px375(282);
      width: px375(146);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchang/shouji.png") center center
        no-repeat;
      background-size: 100% 100%;
    }
    .sucai {
      position: absolute;
      left: px375(114);
      top: px375(392);
      height: px375(270);
      width: px375(260);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchang/sucai.png") center center
        no-repeat;
      background-size: 100% 100%;
    }
    .tubiao {
      position: absolute;
      left: px375(150);
      top: px375(47);
      height: px375(76);
      width: px375(76);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchang/tubiao.svg") center center
        no-repeat;
      background-size: 100% 100%;
    }
    .title {
      position: absolute;
      left: px375(60);
      top: px375(155);
      font-size: px375(22);
      color: #371b2f;
    }
    .text {
      position: absolute;
      left: px375(30);
      top: px375(200);
      font-size: px375(14);
      line-height: px375(35);
      color: #371b2f;
      min-width: px375(314);
      text-align: center;
    }
  }
  .shop {
    .shouji {
      position: absolute;
      left: px375(210);
      top: px375(330);
      height: px375(282);
      width: px375(146);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shop/shouji.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .sucai {
      position: absolute;
      left: px375(0);
      top: px375(400);
      height: px375(151);
      width: px375(266);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shop/sucai.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .tubiao {
      position: absolute;
      left: px375(150);
      top: px375(47);
      height: px375(76);
      width: px375(76);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shop/tubiao.svg") center center no-repeat;
      background-size: 100% 100%;
    }
    .title {
      position: absolute;
      left: 0;
      top: px375(155);
      right: 0;
      font-size: px375(22);
      color: #371b2f;
      // min-width: px375(230);
      text-align: center;
    }
    .text {
      position: absolute;
      left: px375(60);
      top: px375(200);
      font-size: px375(14);
      line-height: px375(35);
      color: #371b2f;
      min-width: px375(254);
      text-align: center;
    }
  }
  .pay {
    .shouji {
      position: absolute;
      left: px375(30);
      top: px375(330);
      height: px375(282);
      width: px375(146);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/pay/shouji.png") center center no-repeat;
      background-size: 100% 100%;
      z-index: 2;
    }
    .sucai {
      position: absolute;
      right: px375(0);
      top: px375(330);
      height: px375(270);
      width: px375(270);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/pay/sucai.png") center center no-repeat;
      background-size: 100% 100%;
      z-index: 1;
    }
    .tubiao {
      position: absolute;
      left: px375(150);
      top: px375(47);
      height: px375(76);
      width: px375(76);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/pay/tubiao.svg") center center no-repeat;
      background-size: 100% 100%;
    }
    .title {
      position: absolute;
      left: 0;
      top: px375(155);
      right: 0;
      font-size: px375(22);
      color: #371b2f;
      // min-width: px375(230);
      text-align: center;
    }
    .text {
      position: absolute;
      left: 0;
      right: 0;
      top: px375(200);
      font-size: px375(14);
      line-height: px375(35);
      color: #371b2f;
      text-align: center;
    }
  }
  .food {
    .shouji {
      position: absolute;
      left: px375(213);
      top: px375(330);
      height: px375(282);
      width: px375(146);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/food/shouji.png") center center no-repeat;
      background-size: 100% 100%;
      z-index: 2;
    }
    .sucai {
      position: absolute;
      left: px375(6);
      top: px375(392);
      height: px375(160);
      width: px375(212);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/food/sucai.png") center center no-repeat;
      background-size: 100% 100%;
      z-index: 1;
    }
    .tubiao {
      position: absolute;
      left: px375(150);
      top: px375(47);
      height: px375(76);
      width: px375(76);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/food/tubiao.svg") center center no-repeat;
      background-size: 100% 100%;
    }
    .title {
      position: absolute;
      left: 0;
      top: px375(155);
      right: 0;
      font-size: px375(22);
      color: #371b2f;
      // min-width: px375(230);
      text-align: center;
    }
    .text {
      position: absolute;
      left: 0;
      right: 0;
      top: px375(200);
      font-size: px375(14);
      line-height: px375(35);
      color: #371b2f;
      text-align: center;
    }
  }
  .youhui {
    .sucai {
      position: absolute;
      left: px375(48);
      bottom: px375(0);
      height: px375(436);
      width: px375(278);
      // background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/youhui/sucai.png") center center no-repeat;
      // background-size: 100% 100%;
      z-index: 1;
      overflow: hidden;
      display: flex;
      justify-content: center;
      .imgItem {
        width: px375(46);
        height: px375(584);
        margin: 0 auto;
        transform: translateY(px375(-50));
        transition: transform 1.5s ease-in;
      }
      .imgTranslate {
        transform: translateY(px375(0));
        &:nth-of-type(2n) {
          transform: translateY(px375(-100));
        }
      }
    }
    .tubiao {
      position: absolute;
      left: px375(150);
      top: px375(47);
      height: px375(76);
      width: px375(76);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/youhui/tubiao.svg") center center no-repeat;
      background-size: 100% 100%;
    }
    .title {
      position: absolute;
      left: 0;
      top: px375(155);
      right: 0;
      font-size: px375(22);
      color: #371b2f;
      // min-width: px375(230);
      text-align: center;
    }
    .text {
      position: absolute;
      left: 0;
      right: 0;
      top: px375(200);
      font-size: px375(14);
      line-height: px375(35);
      color: #371b2f;
      text-align: center;
    }
  }
  .haiwai {
    width: px375(375);
    position: relative;
    .topBg {
      width: 100%;
      height: px375(392);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/haiwai/img1.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .footBg {
      width: 100%;
      height: px375(330);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/haiwai/img2.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .phoneImg {
      width: px375(162);
      height: px375(313);
      position: absolute;
      top: px375(292);
      left: px375(26);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/haiwai/shouji1.png") center center
        no-repeat;
      background-size: 100% 100%;
      &:nth-of-type(2n) {
        background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/haiwai/shouji2.png") center center
          no-repeat;
        background-size: 100% 100%;
        left: px375(188);
      }
    }
    .title {
      font-size: px375(22);
      position: absolute;

      top: px375(105);
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
    }
    .text {
      font-size: px375(14);
      line-height: px375(35);
      position: absolute;
      top: px375(150);
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
    }
  }
  .city {
    width: px375(375);
    position: relative;
    .topBg {
      width: 100%;
      height: px375(392);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/city/img1.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .footBg {
      width: 100%;
      height: px375(330);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/haiwai/img2.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .phoneImg {
      width: px375(162);
      height: px375(313);
      position: absolute;
      top: px375(170);
      left: px375(26);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/city/shouji2.png") center center no-repeat;
      background-size: 100% 100%;
      &:nth-of-type(2n) {
        background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/city/shouji1.png") center center
          no-repeat;
        background-size: 100% 100%;
        left: px375(188);
      }
    }
    .title {
      font-size: px375(22);
      position: absolute;

      top: px375(35);
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
    }
    .text {
      font-size: px375(14);
      line-height: px375(35);
      position: absolute;
      top: px375(81);
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
    }
    .iconBox {
      width: px375(335);
      height: px375(120);
      position: absolute;
      top: px375(532);
      left: px375(20);
      padding: 0 px375(20);
      box-sizing: border-box;
      // .wrapper{
      //   width: px375(1000);
      // }
      .iconItem {
        width: px375(90) !important;
        text-align: center;
        margin: 0 px375(6);
        font-size: px375(10);
        color: #371b2f;
        img {
          width: px375(90);
          height: px375(90);
        }
      }
      .prev {
        width: px375(11);
        height: px375(19);
        background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/city/jiantou_L.svg") center center no-repeat;
        background-size: 100% 100%;
        left: 0;
      }
      .next {
        width: px375(11);
        height: px375(19);
        background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/city/jiantou_L.svg") center center no-repeat;
        background-size: 100% 100%;
        right: 0;
        transform: rotateZ(180deg);
        transform-origin: 50% 50%;
      }
    }
  }
  .shangchangtuiguang {
    width: px375(375);
    position: relative;
    .topBg {
      width: 100%;
      height: px375(392);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/bgImg.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
    .footBg {
      width: 100%;
      height: px375(330);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/haiwai/img2.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .shouji {
      width: px375(162);
      height: px375(313);
      position: absolute;
      top: px375(157);
      left: px375(105);
      // background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/shouji.png") center
      //   center no-repeat;
      // background-size: 100% 100%;
      img {
        width: px375(162);
        height: px375(313);
      }
    }

    .title {
      font-size: px375(22);
      position: absolute;

      top: px375(34);
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
    }
    .text {
      font-size: px375(14);
      line-height: px375(35);
      position: absolute;
      top: px375(80);
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
    }
    .saoma {
      position: absolute;
      right: 0;
      left: 0;
      text-align: center;
      color: #371b2f;
      font-size: px375(10);
      top: px375(463);
    }
    .imgBox {
      width: px375(375);
      height: px375(220);
      position: absolute;
      top: px375(485);
      left: 0;
      .imgItem {
        width: px375(210);
        text-align: center;
        font-size: px375(10);
        color: #371b2f;
        img {
          width: px375(210);
        }
        span {
          width: px375(210);
          display: inline-block;
          padding: 0 px375(16);
          box-sizing: border-box;
        }
      }
    }
    .bianjie {
      font-size: px375(10);
      color: #371b2f;
      text-align: center;
      position: absolute;
      top: px375(496);
      width: 100%;

      .icon {
        width: px375(7);
        height: px375(5);
        background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/shangchangtuiguang/icon.svg") center
          center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: px375(-10);
      }
    }
    .serveIconBox {
      font-size: px375(10);
      color: #371b2f;
      width: px375(375);
      padding: 0 px375(60);
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      top: px375(534);
      left: 0;
      .serveIconItem {
        width: px375(60);
        margin: 0 px375(12);
        margin-bottom: px375(18);
        text-align: center;
        img {
          width: px375(50);
        }
      }
    }
  }
  .footerBox {
    width: px375(375);
    height: px375(722);
    background-color: #fff;
    position: relative;
    .bgBox {
      width: 100%;
      height: px375(507);
      background: url("https://files.easy2walk.com/wwweasy2walk/img/mobile/footer/bgImg.png") center center no-repeat;
      background-size: 100% 100%;
      position: relative;
      .telUs {
        font-size: px375(26);
        color: #371b2f;
        position: absolute;
        top: px375(247);
        left: 50%;
        transform: translateX(-50%);
      }
      .mallBox {
        font-size: 0;
        position: absolute;
        top: px375(420);
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        img {
          width: px375(26);
          height: px375(18);
          margin-bottom: px375(6);
        }
        span {
          font-size: px375(10);
          color: #371b2f;
        }
        .icon {
          width: px375(7);
          height: px375(5);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/footer/icon.svg") center center no-repeat;
          background-size: 100% 100%;
          position: absolute;
          bottom: px375(-10);
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .mallBtn {
        display: block;
        font-size: px375(14);
        color: #fff;
        background-color: #f05d52;
        border-radius: px375(10);
        width: px375(187);
        height: px375(34);
        text-align: center;
        line-height: px375(34);
        position: absolute;
        top: px375(489);
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
      }
    }
    .bottomBox {
      position: relative;
      width: 100%;
      height: px375(215);
      .copy {
        position: absolute;
        bottom: px375(58);
        text-align: center;
        left: 0;
        right: 0;
        font-size: px375(10);
        a{
          display: block;
          margin-top: px375(10);
        }
      }
      .mallBoxSmall {
        font-size: 0;
        position: absolute;
        bottom: px375(82);
        text-align: center;
        left: 0;
        right: 0;
        font-size: px375(10);
        img {
          width: px375(13);
          height: px375(9);
          margin-right: px375(4);
        }
        span {
          font-size: px375(10);
        }
      }
      .logoBox {
        position: absolute;
        bottom: px375(22);
        vertical-align: middle;
        text-align: center;
        left: 0;
        right: 0;
        .logoFenge {
          margin: 0 px375(10);
          height: px375(18);
          width: 1px;
        }
        .logoItem1 {
          // width: px375(60);
          height: px375(10);
        }
        .logoItem2 {
          // width: px375(60);
          height: px375(15);
        }
        .logoItem3 {
          // width: px375(60);
          height: px375(10);
        }
      }
    }
  }
}
.text {
  animation-delay: 0.3s;
}
</style>
